/**
 * Shared tag helpers.
 *
 * Tags are stored as a single comma-separated string in many places (schedule items, templates, etc.).
 * These helpers centralize splitting/joining/normalization.
 */

/** Split a comma-separated tag string into an array of trimmed, non-empty tags. */
export const splitTags = (raw?: string): string[] => {
    if (!raw) return [];

    return raw
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);
};

/**
 * Normalize tags for comparisons/search.
 *
 * Note: this preserves original casing by default; use lowercasing at call sites
 * if you want case-insensitive keys.
 */
export const normalizeTags = (raw?: string): string[] => splitTags(raw).map((t) => t.trim());

/**
 * Convert a tag array back to a comma-separated string.
 *
 * Preserves casing, trims, and de-dupes case-insensitively.
 */
export const tagsToString = (tags: readonly string[]): string => {
    const result: string[] = [];
    const seen = new Set<string>();

    for (const t of tags.map((x) => x.trim()).filter(Boolean)) {
        if (seen.has(t)) continue;
        seen.add(t);
        result.push(t);
    }

    return result.join(', ');
};
